export enum ChainId {
  MAINNET = 1,
  ROPSTEN = 3,
  RINKEBY = 4,
  GOERLI = 5,
  KOVAN = 42,
  BSC = 56,
  BSC_TESTNET = 97,
  MATIC = 137,
  ARBITRUM = 42161,
  MOONRIVER = 1285
}

export const NetworkContextName = 'NETWORK'
